import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, CheckCircle, AlertCircle, Brain } from '../components/icons';

export function InstructionsView() {
  const navigate = useNavigate();

  const instructions = [
    {
      icon: Clock,
      title: 'Take Your Time',
      description: 'The assessment takes approximately 20-30 minutes. Find a quiet space where you can focus without interruptions.'
    },
    {
      icon: CheckCircle,
      title: 'Be Honest',
      description: 'Answer each question based on how you actually feel, not how you think you should feel. There are no right or wrong answers.'
    },
    {
      icon: AlertCircle,
      title: 'Trust Your First Response',
      description: 'Your initial reaction is usually the most accurate. Don\'t overthink your answers.'
    },
    {
      icon: Brain,
      title: 'Consider Real Situations',
      description: 'When answering, think about how you typically behave in real-life situations, not hypothetical scenarios.'
    }
  ];

  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="freud-display-sm text-chocolate-900 mb-4">
            Assessment Instructions
          </h1>
          <p className="freud-text-lg text-chocolate-500">
            Please read these guidelines before starting your assessment.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12">
          {instructions.map((instruction, index) => (
            <motion.div
              key={instruction.title}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="freud-card-elevated p-6"
            >
              <div className="flex items-start gap-4">
                <div className="p-3 bg-sage-100 rounded-xl">
                  <instruction.icon className="w-6 h-6 text-sage-600" />
                </div>
                <div>
                  <h3 className="freud-heading-base text-chocolate-900 mb-2">
                    {instruction.title}
                  </h3>
                  <p className="freud-text-base text-chocolate-600">
                    {instruction.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="bg-sand-100 border border-sand-300 rounded-2xl p-6 mb-8"
        >
          <h3 className="freud-label text-sand-900 mb-2">Rating Scale</h3>
          <p className="freud-text-base text-sand-800 mb-4">
            You'll rate each statement on a scale from 1 to 7:
          </p>
          <div className="flex justify-between freud-text-sm text-sand-700">
            <span>1 = Strongly Disagree</span>
            <span>4 = Neutral</span>
            <span>7 = Strongly Agree</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="text-center"
        >
          <button
            onClick={() => navigate('/assessment')}
            className="freud-btn-primary inline-flex items-center gap-2"
          >
            Begin Assessment
            <ArrowRight className="w-5 h-5" />
          </button>
        </motion.div>
      </div>
    </div>
  );
}
